
export const isShareware = true;

export const extension = isShareware ? "WL1" : "WL6";

export const GAMEMAPS = `GAMEMAPS.${extension}`;

export const MAPHEAD = `MAPHEAD.${extension}`;

export const VSWAP = `VSWAP.${extension}`;

export function isSharewareSprite(index) {
    if ((index <= 186) ? true : ((index >= 296) && (index <= 306))) {
        return true;
    }
    else if (index >= 408) {
        return index <= 435;
    }
    else {
        return false;
    }
}

export function audioFilename(extension_1, soundEffect) {
    const prefix = (soundEffect.tag === 1) ? "001_Dog" : ((soundEffect.tag === 2) ? "002_DoorClose" : ((soundEffect.tag === 3) ? "003_DoorOpen" : ((soundEffect.tag === 4) ? "004_PlayerMachineGun" : ((soundEffect.tag === 5) ? "005_PlayerPistol" : ((soundEffect.tag === 6) ? "006_PlayerChainGun_Question" : ((soundEffect.tag === 7) ? "007_Hooffafo" : ((soundEffect.tag === 8) ? "008_GutenTag" : ((soundEffect.tag === 9) ? "009_Mutti" : ((soundEffect.tag === 10) ? "010_GuardChainGun_Question" : ((soundEffect.tag === 11) ? "011_GuardMachineGun_Question" : ((soundEffect.tag === 12) ? "012_Aaarggh" : ((soundEffect.tag === 13) ? "013_Aieeee" : ((soundEffect.tag === 14) ? "014_Ooof" : ((soundEffect.tag === 15) ? "015_SecretDoor" : ((soundEffect.tag === 16) ? "026_MeinLeben" : ((soundEffect.tag === 17) ? "027_GuardPistol" : ((soundEffect.tag === 18) ? "028_Bubbles_Question" : ((soundEffect.tag === 19) ? "057_VictoryYeah" : ((soundEffect.tag === 20) ? "095_Tick" : "000_UttGuards")))))))))))))))))));
    return `${prefix}.${extension_1}`;
}

